import { SET_PRODUCT_SETTINGS_DATA_LOADING, SET_PRODUCT_SETTINGS_DATA, CLEAR_PRODUCT_SETTINGS_DATA } from './types';
import store from '../../../../store';
import Axios from '../../../../common/util/Axios';

export const findProductSettings = () => async (dispatch) => {
  try {
    dispatch({ type: SET_PRODUCT_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const queryParams = {
      companyId,
    };
    if (!companyId) {
      return false;
    }
    
    const res = await Axios.get('/api/dashboard/settings/find-product-settings-for-branch', {
      params: queryParams,
    });
    console.log(res.data.data);
    dispatch({
      type: SET_PRODUCT_SETTINGS_DATA,
      payload: res.data.data,
    });

    return true;
  } catch (error) {
    dispatch({
      type: SET_PRODUCT_SETTINGS_DATA,
      payload: [],
    });
    return false;
  }
}


export const updateProductSettings = (productSettings) => async (dispatch) => {
  try {
    dispatch({ type: SET_PRODUCT_SETTINGS_DATA_LOADING, payload: true });

    const companyId = store.getState().authState.companyId;
    const branchId = store.getState().authState.branchId;
    
    const requestBody = {
      ...productSettings.productSettingsData,
    };

    const queryParams = {
      companyId,
      branchId,
    };

    const res = await Axios.post(`/api/dashboard/settings/update-product-settings`, requestBody, {
      params: queryParams,
    });
    dispatch({ type: SET_PRODUCT_SETTINGS_DATA_LOADING, payload: false });
    return true;
  } catch (err) {
    dispatch({ type: SET_PRODUCT_SETTINGS_DATA_LOADING, payload: false });
    return false;
  }
};